<template>
  <div>
    <ul>
      <li @click.stop="changeType('now')":class="[{'btn-primary2':type==='now'}]">本月</li>
      <li @click.stop="changeType('before')" :class="[{'btn-primary2':type==='before'}]">自定义</li>
    </ul>
<!--    <Button-->
<!--      size="small"-->
<!--      :type="type==='now'?'primary':'default'"-->
<!--      @click.stop="changeType('now')"-->
<!--    >本月-->
<!--    </Button>-->
<!--    <Button-->
<!--      size="small"-->
<!--      :type="type==='before'?'primary':'default'"-->
<!--      @click.stop="changeType('before')"-->
<!--      style="margin-right: 10px"-->
<!--    >自定义-->
<!--    </Button>-->
    <!--  <DatePicker-->
    <!--    v-show="type==='now'"-->
    <!--    style="width: 200px;"-->
    <!--    v-model="searchData.initTimes"-->
    <!--    split-panels-->
    <!--    type="daterange"-->
    <!--    format="yyyy-MM-dd"-->
    <!--    disabled-->
    <!--  ></DatePicker>-->

    <DatePicker

      v-model="searchData.startMonth"
      type="month"
      :options="startoptions"
      format="yyyy-MM"
      placeholder="请选择起始月"
      :clearable=false
      style="margin-right: 10px;width: 130px;"
      :disabled="type==='now'"
      ref="start"
    ></DatePicker>

    <DatePicker
      ref="end"
      :disabled="type==='now'"
      v-model="searchData.endMonth"
      type="month"
      :options="endoptions"
      format="yyyy-MM"
      placeholder="请选择结束月"
      style="width: 130px;"
      :clearable=false
    ></DatePicker>

    <Button :disabled="type=='now'" @click="ok">确定</Button>

  </div>
</template>

<script>
  export default {
    name: "SelectMonth",
    data() {
      return {
        type: 'now',
        searchData: {
          projectFid: [],
          startMonth: new Date(new Date().setMonth(new Date().getMonth(), 1)),
          endMonth: new Date(new Date().setMonth(new Date().getMonth() + 1, 0))
        }
      }

    },
    mounted(){
      this.$emit('search',this.searchParams)

    },
    computed: {
      searchParams(){
        return {
          current:this.type,
          startDate:this.$refs['start'].publicStringValue,
          endDate:this.$refs['end'].publicStringValue
        }

      },
      startoptions() {
        const that = this;
        return {
          disabledDate(date) {
            return that.searchData && that.searchData.endMonth
                ? date.valueOf() > that.searchData.endMonth.valueOf()
                : false;
          }
        };
      },
      endoptions() {
        const that = this;
        return {
          disabledDate(date) {
            const now = new Date();
            return that.searchData && that.searchData.startMonth
                ? date.valueOf() < that.searchData.startMonth.valueOf() ||
                date.valueOf() > now.setMonth(now.getMonth() , 0)
                : false;
          }
        };
      },

    },
    methods: {
      ok(){
        this.$emit('search',this.searchParams)

      },
      changeType(value) {
        this.type = value;
        if (this.type === 'now') {
          this.searchData.startMonth = new Date(new Date().setMonth(new Date().getMonth(), 1))
          this.searchData.endMonth = new Date(new Date().setMonth(new Date().getMonth() + 1, 0))
          this.$nextTick(()=>{
          this.$emit('search',this.searchParams)
          })
        }
        if(this.type==='before'){
          this.searchData.startMonth = new Date(new Date().setMonth(new Date().getMonth()-1, 1))
          this.searchData.endMonth = new Date(new Date().setMonth(new Date().getMonth() , 0))

        }
      },
    }
  }
</script>

<style scoped>
  ul, li {
    display: inline-block;
  }

  ul li {
    cursor: pointer;
    margin-right: 10px;
  }

</style>
